import { withAppConfig } from '../../../../../../../appConfigContext';
import { withFeatureFlags } from '../../../../../../../userProfile/featureFlagsContext';
import { withUserProfile } from '../../../../../../../userProfile/userProfileContext';
import appConstants from '../../../../../../../appConstants';
import { compose } from 'recompose';
import { inject } from 'mobx-react';
import { getProNumberValidationFunctions } from '@shared/pro-number-validation';
import { getErrorMessage } from './utils';

export function withProValidationHOC(Component) {
  const UpdatedComponent = (props) => {
    const proNumberMinLength = props.DispatchStore.staticClientData?.clientCodes?.minProLength;
    const proNumberMaxLength = props.DispatchStore.staticClientData?.clientCodes?.proNumberLength;
    const terminalCode = props.userData?.userProfile?.terminal?.code;
    const clientName = props.configJSON?.proValidation;
    const enableCheckDigit = props.featureFlags.isFeatureEnabled(
      appConstants.features.CheckDigitRequired
    );

    const { validateProNumber, getProNumberWithCheckDigit } = getProNumberValidationFunctions({
      clientName,
      enableCheckDigit,
      proNumberLengthConstraints: {
        minLength: proNumberMinLength,
        maxLength: proNumberMaxLength
      },
      metaData: {
        terminalCode
      }
    });

    const validateProNumberWithErrorMessage = (params) => {
      const error = validateProNumber(params);
      return error ? getErrorMessage(error) : null;
    };

    const proValidation = {
      getProNumber: getProNumberWithCheckDigit,
      validateProNumber: validateProNumberWithErrorMessage
    };

    return <Component {...props} proValidation={proValidation} />;
  };

  return compose(
    inject('DispatchStore'),
    withFeatureFlags,
    withAppConfig,
    withUserProfile
  )(UpdatedComponent);
}
